export default "__VITE_ASSET__DJS2zVtD__"